import Button from "./button";
import SbEditable from "storyblok-react";
import { useRouter } from "next/router";
import { FoundationsButtonStoryblok } from "@/types/component-types-sb";
import styles from "./button.module.scss";
import classnames from "classnames";
import { useState } from "react";

interface Props {
  blok: FoundationsButtonStoryblok;
  className?: string;
}

const FoundationsButton = (props: Props) => {
  const {
    blok: {
      link,
      text,
      size,
      style,
      accent_color,
      icon,
      frequency = "month",
      country = "",
    },
    className,
  } = props;
  const router = useRouter();
  const [plan, setPlan] = useState<"monthly" | "annual">("monthly");

  const linkParams = new URLSearchParams(
    Object.fromEntries(
      Object.entries({
        regularity: frequency,
        country:
          (Array.isArray(router.query.country) ? null : router.query.country) ||
          country,
      }).filter(([, value]) => !!value)
    )
  ).toString();

  return (
    // @ts-expect-error
    <SbEditable content={props.blok}>
      <div>
        <div className={styles.switcherWrapper}>
          <div>Monthly</div>
          <label className={styles.switch}>
            <input
              type="checkbox"
              checked={plan === "annual"}
              onChange={(e) => {
                if (e.target.checked) {
                  setPlan("annual");
                } else {
                  setPlan("monthly");
                }
              }}
            />
            <span className={classnames(styles.slider, styles.round)}></span>
          </label>
          <div className="relative">
            <div>Annual</div>
            <span className="absolute whitespace-nowrap text-xs">
              Save two months vs. monthly plan
            </span>
          </div>
        </div>
        <div className={styles.foundationsButtonWrapper}>
          <Button
            size={size}
            btnStyle={style}
            accent_color={accent_color}
            icon={icon || undefined}
            className={className}
            link={
              plan === "monthly"
                ? link
                : "https://app.teamefcoaching.com/offers/aneZzhoL"
            }
            linkParams={linkParams}
          >
            {text}
          </Button>
        </div>
      </div>
    </SbEditable>
  );
};

export default FoundationsButton;
